module.exports = __webpack_public_path__ + "img/f-12.1c9fd162.jpg";